/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R2_PurposeInputs */

const tr_cerez_s3_r2_purpose = /** @type {(inputs: Cerez_S3_R2_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çoklu firma desteği için aktif firma seçimi`)
};

const en_cerez_s3_r2_purpose = /** @type {(inputs: Cerez_S3_R2_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active company selection for multi company support`)
};

const de_cerez_s3_r2_purpose = /** @type {(inputs: Cerez_S3_R2_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl der aktiven Firma für die Mehrfirmen-Unterstützung`)
};

const ru_cerez_s3_r2_purpose = /** @type {(inputs: Cerez_S3_R2_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор активной компании для поддержки нескольких компаний`)
};

/**
* | output |
* | --- |
* | "Active company selection for multi company support" |
*
* @param {Cerez_S3_R2_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r2_purpose = /** @type {((inputs?: Cerez_S3_R2_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R2_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r2_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r2_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r2_purpose(inputs)
	return tr_cerez_s3_r2_purpose(inputs)
});